// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"73850b33","732":"d14b0a20","952":"752e13e3","977":"4b93f112"}[chunkId] + ".chunk.js";
};